<skeleton-rectangle [height]="4"></skeleton-rectangle>
<skeleton-rectangle [height]="4"></skeleton-rectangle>
<skeleton-rectangle [height]="4"></skeleton-rectangle>
